import { BodyText, Flex, HelperText } from '@utilitywarehouse/hearth-react';

import {
  type Appointment,
  AppointmentParticipantType,
} from '@generated/gql/graphql';

import './styles.scss';

interface PreJoinInfoProps {
  appointment: Appointment;
  userId: string;
}

const PreJoinInfo = ({ appointment, userId }: PreJoinInfoProps) => {
  const hostPartner = appointment.participants.find((participant) => {
    return participant.type === AppointmentParticipantType.Partner;
  });

  const participantNames = appointment.participants.reduce(
    (acc, participant): string[] => {
      if (participant.id !== userId) {
        return [...acc, participant.name];
      }
      return acc;
    },
    []
  );

  const hasParticipants = participantNames.length > 0;

  return (
    <Flex direction="row" className="preJoin__Info">
      <Flex
        direction="column"
        spacing="xs"
        className="preJoin__InfoItem preJoin__InfoItem--id"
      >
        <HelperText>Appointment code</HelperText>
        <BodyText size="lg" weight="semibold">
          {appointment.id}
        </BodyText>
      </Flex>
      <Flex
        direction="column"
        spacing="xs"
        className="preJoin__InfoItem preJoin__InfoItem--host"
      >
        <HelperText>Hosting partner</HelperText>
        <BodyText size="lg" weight="semibold">
          {hostPartner?.name ?? 'Unknown'}
        </BodyText>
      </Flex>
      <Flex
        direction="column"
        spacing="xs"
        justifyContent={hasParticipants ? 'start' : 'center'}
        className="preJoin__InfoItem preJoin__InfoItem--participants"
      >
        {!hasParticipants && <HelperText>No one else is here</HelperText>}
        {hasParticipants && (
          <>
            <HelperText>
              {participantNames.length}{' '}
              {participantNames.length === 1 ? 'person' : 'people'} in this
              appointment
            </HelperText>
            <BodyText size="lg" weight="semibold">
              {participantNames.join(', ')}
            </BodyText>
          </>
        )}
      </Flex>
    </Flex>
  );
};

export { PreJoinInfo };
